import { useBookingContext } from '@providers/booking'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { Hooks } from 'service-api'
import { Spacer1, Spacer2, Spacer3 } from 'components-ui'
import { Footer } from 'components/footer'
import { Logo } from 'components/logo'
import { SearchBar } from 'components/search_bar'
import { ServiceTypeSelector } from 'components/service_type_selector'
import { useLocationContext } from '@providers/location'
import { Box } from '@mui/material'
import { useUserStatus } from 'hooks/use_userstatus'
import { STICKY_HEADER_HEIGHT_PX } from '@shared/constants'

export const Booking = () => {
  const { accountName = '', serviceTypeName = 'boarding' } = useParams()
  const ctx = useBookingContext()
  const userStatus = useUserStatus()
  const { location, locationTheme, isLoading: isLoadingLocation } = useLocationContext()
  const serviceTypes = Hooks.useClientLocationServiceType(accountName, {
    restrictions: true,
  })
  const configs = Hooks.useClientBookingConfigs(accountName, serviceTypeName)

  const st = serviceTypes.data?.results?.find((st) => st.name === serviceTypeName)
  const serviceTypeConfig = Hooks.useClientLocationBookingConf(accountName, st?.id)
  const species = Hooks.useClientLocationSpecies(accountName, true)
  const petProfiles = Hooks.useClientPetProfiles(accountName, userStatus.isLoggedIn && species.isSuccess)

  useEffect(() => {
    if (petProfiles.data && !ctx.state.data.petProfiles) {
      ctx.dispatch({
        type: 'SET_PET_PROFILES',
        payload: { value: petProfiles.data.results },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [petProfiles.data])

  useEffect(() => {
    if (configs.data) {
      ctx.dispatch({
        type: 'SET_BOOKING_CONFIG',
        payload: { value: configs.data, serviceTypeName: serviceTypeName },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configs.data])

  useEffect(() => {
    if (serviceTypeConfig.data) {
      ctx.dispatch({
        type: 'SET_SERVICE_TYPE_CONFIG',
        payload: { value: serviceTypeConfig.data?.results },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTypeConfig.data?.results])

  useEffect(() => {
    if (species.data) {
      ctx.dispatch({
        type: 'SET_SPECIES_CONFIG',
        payload: { value: species.data?.results },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [species.data])

  useEffect(() => {
    if (location) {
      ctx.dispatch({
        type: 'SET_LOCATION_CONFIG',
        payload: { value: location },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    if (serviceTypes.data) {
      const temperTest = serviceTypes.data.results.find((s) => s.serviceType!.name === 'temper-test')
      ctx.dispatch({ type: 'SET_TEMPER_TEST_DATA', payload: { value: temperTest } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTypes.data])

  useEffect(() => {
    if (st) {
      ctx.dispatch({ type: 'SET_SERVICE_TYPE', payload: { value: st } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [st?.id])

  return (
    <Box
      sx={{
        height: `calc(100vh - ${STICKY_HEADER_HEIGHT_PX}px)`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <Spacer1 />
        <Logo isLoading={isLoadingLocation} asset={locationTheme?.logo?.[0]?.asset} location={location} />
        <Spacer2 />
        <ServiceTypeSelector isLoading={serviceTypes.isLoading} services={serviceTypes.data?.results || []} />
        <Spacer3 />
        <SearchBar />
      </div>
      <div>
        <Footer />
        <Spacer3 />
      </div>
    </Box>
  )
}
